import AppModal from '@/components/AppModal/AppModal';
import { config } from '@/config';
import { openErrorToast, openToast } from '@/helpers';
import { useGetGeneralSettingQuery, useUpdateGeneralSettingMutation } from '@/redux/query';
import { Checkbox } from '@shopify/polaris';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

interface Props {
  open: boolean;
  onCancel: () => void;
  isActiveAction: boolean;
}

export const ActionModal = ({ open, onCancel, isActiveAction }: Props) => {
  const { t } = useTranslation('orderReport');
  const [checked, setChecked] = useState(isActiveAction);
  const handleChange = useCallback((newChecked: boolean) => setChecked(newChecked), []);
  const dispatch = useDispatch();

  const { refetch: refetchGetGeneralSetting } = useGetGeneralSettingQuery({ shop: config.shop });
  const [updateGeneralSetting, { isLoading: isLoadingUpdateGeneralSetting }] = useUpdateGeneralSettingMutation();

  const handleChangeActiveAction = () => {
    updateGeneralSetting({
      shop: config.shop,
      isAutoFullfillmentAction: checked,
    })
      .unwrap()
      .then(() => {
        refetchGetGeneralSetting();
        openToast(dispatch);
        onCancel();
      })
      .catch(() => openErrorToast(dispatch));
  };

  return (
    <AppModal
      open={open}
      onCancel={onCancel}
      onSubmit={handleChangeActiveAction}
      title={t('reportTable.action.title')}
      submitText={t('reportTable.action.submit')}
      loading={isLoadingUpdateGeneralSetting}
    >
      <Checkbox
        label={t('reportTable.action.checkboxLabel')}
        helpText={t('reportTable.action.checkboxHelpText')}
        checked={checked}
        onChange={handleChange}
      />
    </AppModal>
  );
};
